import { get } from 'lodash/fp';
import useValidator from '../../../utilities/useValidator';
import validators from '../../../utilities/validators';

const validator = validators.compose(
    validators.requiredString('labelName.defaultValue'),
    validators.custom('labelName.defaultValue', (max, values, errors, context) => {
        const labelValue = get('labelName.defaultValue', values);

        if (!labelValue) {
            return context.defaultMessages.requiredString;
        }
        if (labelValue.length > 25) {
            return context.outerContext.t?.('common:formErrors.maxInputCount', { max: 25 });
        }

        return null;
    }),
    validators.custom('moduleIds', (max, values, errors, context) => {
        const moduleIdsList = get('moduleIds', values);

        if (!Array.isArray(moduleIdsList) || moduleIdsList.length < 1) {
            return context.defaultMessages.minArrayInput;
        }

        return null;
    }),
    validators.requiredColorHex('textColor'),
    validators.requiredColorHex('backgroundColor'),
    validators.requiredBoolean('isActive')
);

const useLabelsValidator = () => useValidator(validator);

export default useLabelsValidator;
